import React, { useRef } from "react"
import Autocomplete from "./Autocomplete"
import CenterButton from "./CenterButton"
import CustomDrawingManager from "./DrawingManager"
import Map from "./Map"
import MapControl from "./MapControl"

type CustomGoogleMapProps = {
  children?: React.ReactNode
  onPolyComplete?: any
  onCenterMapClicked?: any
  onLoad?: any
  center?: any
  onChange?: any
  drawingMode?: any
  onClick?: any
  styles?: any
  mapContainerSytle?: React.CSSProperties
  mapContainerClassName?: string
}
const CustomGoogleMap = ({
  children,
  onPolyComplete,
  onCenterMapClicked,
  onLoad,
  center,
  onChange,
  drawingMode,
  onClick,
  styles,
  mapContainerSytle,
  mapContainerClassName,
}: CustomGoogleMapProps) => {
  const mapRef = useRef<any>()

  return (
    <Map
      mapContainerClassName={mapContainerClassName}
      onClick={onClick}
      onLoad={map => {
        mapRef.current = map
        onLoad && onLoad(map)
      }}
      id="mv-map"
      mapContainerStyle={{
        position: "relative",
        height: "50vh",
        width: "100%",
        ...mapContainerSytle,
      }}
      zoom={15}
      center={center}
      styles={styles}
    >
      {onCenterMapClicked && (
        <MapControl position="BOTTOM_CENTER">
          <CenterButton
            id="vt_center_button_control"
            className="mb-3 vt-center-button-control"
            onClick={onCenterMapClicked}
          />
        </MapControl>
      )}
      {onChange ? <Autocomplete onChange={onChange} /> : undefined}
      {onPolyComplete && drawingMode && (
        <CustomDrawingManager
          onPolyComplete={onPolyComplete}
          drawingMode={drawingMode}
        />
      )}
      {children}
    </Map>
  )
}

export default CustomGoogleMap
